import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

/*
 * Check if the password reset token is valid
 */
export function useCheckPasswordResetToken(userId: string, token: string) {
  const $httpFetch = useHttpFetch()

  return useAsyncData(() =>
    $httpFetch('/auth/password-reset/check-token', {
      method: 'POST',
      body: {
        user_id: userId,
        token,
      },
    }),
  )
}
